/**
 * Maps GET /venues/{id}/dashboard-bundle (database-api) to useVenueDashboardData bundle keys.
 */
export const mapDashboardBundleResponse = (api, { transformOperatingHoursList }) => {
  if (!api?.venue) return null;
  return {
    hours: transformOperatingHoursList(api.operating_hours),
    holidayData: Array.isArray(api.holidays) ? api.holidays : [],
    pricingData: Array.isArray(api.dynamic_pricing) ? api.dynamic_pricing : [],
    defaultPerPersonData: api.default_per_person_price ?? null,
    dynamicPerPersonData: Array.isArray(api.dynamic_pricing_per_person)
      ? api.dynamic_pricing_per_person
      : [],
    venueData: api.venue,
    addOnItemsData: Array.isArray(api.addon_items) ? api.addon_items : [],
    otherItemsData: Array.isArray(api.other_items) ? api.other_items : [],
    packagesData: Array.isArray(api.packages) ? api.packages : [],
    spacesData: Array.isArray(api.spaces) ? api.spaces : [],
    flatPricingData: Array.isArray(api.flat_pricing) ? api.flat_pricing : [],
    bookingRulesData: api.booking_rules ?? null,
    perPersonHoursData: transformOperatingHoursList(api.operating_hours_per_person)
  };
};

export const isVenueDashboardBundleEnabled = () =>
  process.env.REACT_APP_VENUE_DASHBOARD_BUNDLE !== '0';
